import { render, staticRenderFns } from "./SelectedTicketAdmin.vue?vue&type=template&id=6373b4f8&scoped=true"
import script from "./SelectedTicketAdmin.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectedTicketAdmin.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SelectedTicketAdmin.vue?vue&type=style&index=0&id=6373b4f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6373b4f8",
  null
  
)

export default component.exports